import React, { useEffect } from 'react';

const Staff = () => {
  return (
    <table>
      <tbody>
        <tr className={'head'}>
          <td>
            <p>実行委員会代表</p>
          </td>
          <td>
            <p>河野 真歩</p>
          </td>
        </tr>
        <tr className={'head'}>
          <td>
            <p>- 企画</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>キュレーター / 展示コンセプト</p>
          </td>
          <td>
            <p>maya masuda</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>テキスト執筆 / 編集</p>
          </td>
          <td>
            <p>maya masuda</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>テキスト校正</p>
          </td>
          <td>
            <p>堀井 野の花　瀬尾 美月</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>イベント</p>
          </td>
          <td>
            <p>伊藤 遥　うしお鶏</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>ゾーニング</p>
          </td>
          <td>
            <p>うしお鶏　simsuke</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>レセプション</p>
          </td>
          <td>
            <p>桐谷 友佳　王婕妤 WANG Jieyu　たまちゃんズ　遠藤 サナ　堀井 野の花</p>
          </td>
        </tr>
        <tr className={'head'}>
          <td>
            <p>- 美術広報</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>アートディレクション</p>
          </td>
          <td>
            <p>米澤 柊　坂田 晶</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>デザイン監督</p>
          </td>
          <td>
            <p>米澤 柊</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>サイン計画</p>
          </td>
          <td>
            <p>lowpolydog</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>紙面デザイン</p>
          </td>
          <td>
            <p>米澤 柊　瀬尾 美月　Megumi Yamaya　lowpolydog</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>ウェブ</p>
          </td>
          <td>
            <p>坂田 晶　柴田 将希</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>音楽</p>
          </td>
          <td>
            <p>lowpolydog</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>映像</p>
          </td>
          <td>
            <p>米澤 柊　sung doohyun</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>撮影補助</p>
          </td>
          <td>
            <p>松岡 琴美　ならぶき りく（ 本コース3年 ）</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>撮影協力</p>
          </td>
          <td>
            <p>高橋 遼平　鈴木しおり　堀井 野の花　瀬尾 美月　柴田 将希　遠藤 サナ</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>システムエンジニア / 運営ツール開発</p>
          </td>
          <td>
            <p>坂田 晶</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>SNS運営</p>
          </td>
          <td>
            <p>米田 宙瑠</p>
          </td>
        </tr>
        <tr className={'head'}>
          <td>
            <p>- 展示</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>代表</p>
          </td>
          <td>
            <p>simsuke</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>代表補佐</p>
          </td>
          <td>
            <p>栗原 昇一</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>機材管理</p>
          </td>
          <td>
            <p>鈴木しおり　タケカワアヤセ　おおもり なほ　AKI雨</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>搬入出管理</p>
          </td>
          <td>
            <p>高橋 遼平　AKI雨</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>会場</p>
          </td>
          <td>
            <p>栗原 昇一　安齋 萌々香　みとあい　おおもり なほ　simsuke</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>展示補助</p>
          </td>
          <td>
            <p>三好るき</p>
          </td>
        </tr>
        <tr className={'head'}>
          <td>
            <p>- 制作進行</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>代表</p>
          </td>
          <td>
            <p>河野 真歩</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>副代表</p>
          </td>
          <td>
            <p>鈴木さゆり</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>会計</p>
          </td>
          <td>
            <p>鈴木さゆり　竹嶋 菖</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>協賛</p>
          </td>
          <td>
            <p>大岡 春香　大白 悠希</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>マネージャー</p>
          </td>
          <td>
            <p>渡部 空（企画）　荒井 流衣（美術広報）　沙羽（展示）</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>アシスタント</p>
          </td>
          <td>
            <p>吉原 優妃（企画）　ましみ　舛森 美奈　めとこ（美術広報）　浅野 文（展示）</p>
          </td>
        </tr>
        <tr className={'head'}>
          <td>
            <p>- 外部協力</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>撮影</p>
          </td>
          <td>
            <p>竹久直樹 takehisanaoki.com</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>印刷</p>
          </td>
          <td>
            <p>株式会社 北斗社 hoku.co.jp</p>
            <p>プリンティングイン pico-net.com</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>配信協力</p>
          </td>
          <td>
            <p>屋上 okujoh.space</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>運送</p>
          </td>
          <td>
            <p>ACトランスポート</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>設営補助</p>
          </td>
          <td>
            <p>加藤 広太　伊藤 銀児　梅田 こゆき　梅田 百茂子　押本 真優　川久保 開　後藤 華子　齊藤 美良　森 優也 （ 本コース学生 ）</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>協賛</p>
          </td>
          <td>
            <p>アドビシステムズ株式会社　株式会社セルシス　株式会社レベルファイブ　株式会社アドブレーン　株式会社オライリー・ジャパン　株式会社コマデン　フジカット有限会社　プリンティング株式会社　吉田金糸店　フォスター電機株式会社</p>
          </td>
        </tr>
        <tr>
          <td>
            <p>スペシャルサンクス（敬称略）</p>
          </td>
          <td>
            <p>唐沢 博幸（ 株式会社 北斗社 ）　メディア芸術コース研究室</p>
          </td>
        </tr>
      </tbody>
    </table >
  )
}


export default Staff